<!--
  Generated template for the WelcomePage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-content fullscreen no-bounce class="tutorial-page">
    <ion-slides pager *ngIf="os == 'ios'">
        <ion-slide class="p1">
            <div class="pattern-bg">
            </div>
            <div class="vertical-center-outer">
                <div class="vertical-center-inner">

                    <img src="/assets/imgs/tutorial/{{ 'TUTORIAL_FIRST_PIC' | translate }}" alt="sporttypes"
                        class="slide-image" />
                    <p>{{ 'TUTORIAL_LOCATION_1' | translate }}</p>

                </div>
            </div>
        </ion-slide>
        <ion-slide class="p1">
            <div class="pattern-bg" [style.background]="background"></div>
            <div class="vertical-center-outer">
                <div class="vertical-center-inner">
                    <h4 style="margin-bottom: 30px;" text-bold padding-top>{{ 'TUTORIAL_LOCATION_2' | translate }}</h4>
                    <br>
                    <img src=" /assets/imgs/tutorial/{{ 'TUTORIAL_SECOND_PIC' | translate }}" alt="sporttypes"
                        class="slide-image" />
                    <h4>{{ 'TUTORIAL_LOCATION_3' | translate }}</h4>
                    <button ion-button (click)="doneIOS()">{{ 'TUTORIAL_EINSTELLEN' | translate }}</button>
                </div>
            </div>
        </ion-slide>
    </ion-slides>

    <ion-slides pager *ngIf="os == 'android'">
        <ion-slide class="p1">
            <ion-toolbar>
                <ion-buttons end>
                    <button ion-button color="primary" (click)="cancel()">{{ 'GLOBAL_CANCEL' | translate}}</button>
                </ion-buttons>
            </ion-toolbar>
            <div class="pattern-bg">
            </div>
            <div class="vertical-center-outer">
                <div class="vertical-center-inner">
                    <img src="/assets/imgs/tutorial/{{ 'TUTORIAL_FIRST_ANDROID_PIC' | translate }}" alt="sporttypes"
                        class="slide-image" />
                    <p>{{ 'TUTORIAL_LOCATION_1' | translate }}</p>
                </div>
            </div>
        </ion-slide>
        <ion-slide class="p1">
            <div class="pattern-bg">
            </div>
            <div class="vertical-center-outer">
                <div class="vertical-center-inner">
                    <h4 style="margin-bottom: 30px;" text-bold padding-top>
                        {{ 'TUTORIAL_LOCATION_ANDROID_2' | translate }}</h4>
                    <br>
                    <img src="/assets/imgs/tutorial/{{ 'TUTORIAL_SECOND_ANDROID_PIC' | translate }}" alt="sporttypes"
                        class="slide-image" />
                    <h4>{{ 'TUTORIAL_LOCATION_3' | translate }}</h4>
                    <button ion-button (click)="doneANDROID()">{{ 'TUTORIAL_EINSTELLEN' | translate }}</button>
                </div>
            </div>
        </ion-slide>
    </ion-slides>
</ion-content>